import React from 'react';
import { Card, Skeleton } from 'styles';

export const LoadingCta = props => (
  <Card small={{ margin: { left: '16px', right: '16px' } }} {...props}>
    <Card.Header>
      <Skeleton
        data-testid="loading-cta"
        height="40px"
        variant="secondary"
        width="calc(100% - 52px)"
        withShimmer
      />
      <Skeleton
        borderRadius="50%"
        height="32px"
        variant="secondary"
        width="32px"
        withShimmer
      />
    </Card.Header>
    <Card.Content>
      <Skeleton
        height="72px"
        margin={{ bottom: '32px', top: '8px' }}
        variant="secondary"
        width="100%"
        withShimmer
      />
      <Skeleton height="48px" variant="tertiary" width="100%" withShimmer />
    </Card.Content>
  </Card>
);
